module.exports = __webpack_public_path__ + "img/体验版.f3caa9fb.png";